<template>
  <div class="list-table">
    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
      >
        <v-flex lg12>
          <v-card>
            <v-card-title>
              <v-btn
                v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR"
                round
                color="success"
                class="text-none"
                @click="gerarRelatorioExcelListaRecursosHabilitacao"
              >
                Gerar Relatório Excel
              </v-btn>
              <v-spacer />
              <v-text-field
                v-model="pesquisar"
                append-icon="search"
                label="Pesquisar"
                single-line
                hide-details
              />
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="listaRecursos"
                :pagination.sync="pagination"
                :total-items="totalItems"
                :loading="loading"
                :search="pesquisar"
                item-key="co_usuario"
                class="elevation-1"
                disable-initial-sort
              >
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <td>{{ props.item.habilitacaoOrganizacao.organizacao.cnpj_formatado }}</td>
                  <td>{{ props.item.habilitacaoOrganizacao.organizacao.no_organizacao }}</td>
                  <td>{{ props.item.dh_cadastro | formatDate }}</td>
                  <td>
                    <v-chip
                      text-color="white"
                      :color="props.item.st_parecer != -1 ? (props.item.st_parecer == 1? 'success' : 'error') : 'warning'"
                    >
                      {{ props.item.st_parecer != -1 ? (props.item.st_parecer == 1? 'Deferido' : 'Indeferido') : 'Pendente' }}
                    </v-chip>
                  </td>
                  <td>{{ props.item.st_validado ? 'Sim' : 'Não' }}</td>
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          depressed
                          outline
                          icon
                          fab
                          dark
                          color="primary"
                          small
                          v-on="on"
                          @click="editarItemModal(props.item)"
                        >
                          <v-icon v-if="props.item.st_parecer === null">
                            gavel
                          </v-icon>
                          <v-icon v-else>
                            remove_red_eye
                          </v-icon>
                        </v-btn>
                      </template>
                      <span v-if="props.item.st_parecer === null">Avaliar</span>
                      <span v-else>Visualizar</span>
                    </v-tooltip>
                  </td>
                </template>
              </v-data-table>
              <lista-habilitacao-organizacao-recurso-dialog
                v-model="mostrarModalEdicao"
                :recursoHabilitacaoOrganizacao="itemEditado"
                @salvo="atualizar"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import ListaHabilitacaoOrganizacaoRecursoDialog from './ListaHabilitacaoOrganizacaoRecursoDialog';
import codigosPerfil from '../../conta/utils/codigosPerfil';

export default {
  name: 'ListaHabilitacaoOrganizacaoRecurso',
  components: {
    ListaHabilitacaoOrganizacaoRecursoDialog,
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
  },
  data() {
    return {
      codigosPerfil,
      loading: true,
      pesquisar: '',
      mostrarModalEdicao: false,
      usuarioLogado: {},
      listaRecursos: [],
      itemEditado: {},
      perfilUsuarioLogado: {},
      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
      totalItems: 0,
      headers: [
        {
          text: 'CNPJ',
          value: 'cnpj_formatado',
        },
        {
          text: 'Razão Social',
          value: 'no_razao_social',
        },
        {
          text: 'Data solicitação',
          value: 'perfil.ds_perfil',
        },
        {
          text: 'Status',
          value: 'st_parecer',
        },
        {
          text: 'Verificado',
          value: 'st_parecer_final',
        },
        {
          text: 'Ações',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    usuarioLogado() {
      this.loadRecursosPorAvaliador(this.usuario.co_usuario).finally((response) => {
        this.listaRecursos = response;
      });
    },
    recursosPorAvaliadorGetter() {
      this.listaRecursos = this.recursosPorAvaliadorGetter;
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({
      ativarRecursoHabilitacaoOrganizacao: 'fase/ativarRecursoHabilitacaoOrganizacao',
      recursosPorAvaliadorGetter: 'recurso/recursos',
      usuario: 'conta/usuario',
      perfil: 'conta/perfil',
    }),
  },
  methods: {
    ...mapActions({
      loadRecursosPorAvaliador: 'recurso/loadRecursosPorAvaliador',
      tratarUsuarioLogado: 'conta/tratarUsuarioLogado',
      gerarRelatorioExcelListaRecursosHabilitacaoAction: 'recurso/exportarExcelListaRecursosHabilitacao',
      definirMensagemErro: 'app/setMensagemErro',
    }),
    gerarRelatorioExcelListaRecursosHabilitacao() {
      this.gerarRelatorioExcelListaRecursosHabilitacaoAction();
    },
    editarItemModal(item) {
      this.itemEditado = item;
      this.mostrarModalEdicao = true;
    },
    checkRecursoHabiliatcao() {
        if (
            this.perfil.co_perfil != codigosPerfil.CODIGO_ADMINISTRADOR 
            && this.perfil.co_perfil != codigosPerfil.CODIGO_AVALIADOR 
            && !this.isFaseRecursoHabiliatcao()
        ) {
            this.definirMensagemErro('O prazo de recurso da habilitação está encerrado!');
            this.$router.push('/');
        }
    },
    isFaseRecursoHabiliatcao() {
      return this.ativarRecursoHabilitacaoOrganizacao;
    },
    atualizar(){
      this.listaRecursos = [];
      this.loading = true
      this.loadRecursosPorAvaliador(this.usuario.co_usuario);
    }
  },
  mounted() {
    const self = this;
    this.tratarUsuarioLogado().finally((response) => {
      this.usuarioLogado = response;
    });
    self.loading = true;
    this.checkRecursoHabiliatcao();
  },
};
</script>
